/**
 * Created by Balazs Foldesi on 2017. 10. 26.
 */
export default {
	DEVICE_CARD_SLIDER_PARAMS: {
		freeMode: true,
		loop: false,
		loopedSlides: 0,
		scrollbar: '.rwkamp-slider-scrollbar',
		scrollbarHide: false,
		scrollbarDraggable: true,
		mousewheelControl: true,
		slideClass: 'rwkamp-slider-col',
		centeredSlides: false,
		grabCursor: true,
		slidesPerView: 'auto',
		spaceBetween: 0,
		breakpoint: 768
	},
	DEVICE_CARD_SLIDER_SELECTORS: {
		SLIDER_WRAPPER_SELECTOR: '.rwkamp-slider-content',
		ENABLED_CLASSNAME: 'rwkamp-slider--enabled',
		NEXT_BUTTON_SELECTOR: '.rwkamp-slider-controls-next',
		PREV_BUTTON_SELECTOR: '.rwkamp-slider-controls-prev'
	},
	BOX_HEIGHTS_CONTAINER_SELECTOR: '.js-box-heights',
	BOX_HEIGHTS_TITLE_ITEM_SELECTOR: '.title-equal-heights',
	SLIDER_CONTAINER_SELECTOR: '.rwkamp-slider .rwkamp-slider-container',
	MD_PANEL_SELECTOR: '.md-panel',
	PICTURE_TAG_SELECTOR: '.picturetag-cover',
	CAMPAIGN_BOX: '.campaign-box',
	DEFAULT_CAMPAIGN_BOX: '.default-campaign-box'
};
